import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import { Button, Tab, TabBody, Tabs } from 'react95';
import packageInfo from '../../../../package.json';
import './MyComputerApp.css';
import { HardwarePanel, DiagnosticsPanel, CreditsPanel } from './SystemPanels';
import UpdatesPanel from './UpdatesPanel';

const tabs = ['常规', '硬件', '诊断', '更新', '致谢'];

export default function MyComputerApp({ onClose }) {
  const [activeTab, setActiveTab] = useState(0);
  const theme = useTheme();

  return (
    <div className="my-computer-app" style={{
      '--system-field': theme.canvas,
      '--system-text': theme.canvasText,
      '--system-light': theme.borderLightest,
      '--system-dark': theme.borderDark
    }}>
      <Tabs value={activeTab} onChange={setActiveTab} aria-label="系统属性" className="my-computer-tabs">
        {tabs.map((label, index) => (
          <Tab key={label} value={index} id={`system-tab-${index}`} aria-controls={`system-panel-${index}`}>{label}</Tab>
        ))}
      </Tabs>
      <TabBody className="my-computer-panel">
        <section role="tabpanel" id="system-panel-0" aria-labelledby="system-tab-0" hidden={activeTab !== 0}>
          <div className="system-panel-heading">
            <span className="system-channel" aria-hidden="true">01 / SYSTEM</span>
            <h2>一台装着夏天的计算机 🌤️</h2>
          </div>
          <div className="my-computer-overview">
            <div className="my-computer-showcase">
              <svg className="my-computer-illustration" viewBox="0 0 144 160" role="img" aria-label="Vintage Vibe CRT 显示器" shapeRendering="crispEdges">
                <path fill="#fff" d="M4 8h132v104H4z" />
                <path fill="#0a0a0a" d="M136 8h4v108H4v-4h132z" />
                <path fill="#c0c0c0" d="M8 12h124v96H8z" />
                <path fill="#808080" d="M16 20h108v76H16z" />
                <path fill="#0a0a0a" d="M20 24h100v68H20z" />
                <path fill="#302047" d="M24 28h92v60H24z" />
                <path fill="#542558" d="M24 50h92v20H24z" />
                <path fill="#ffcf88" d="M62 34h16v2h6v4h4v4H52v-4h4v-4h6z" />
                <path fill="#ff9b89" d="M50 45h40v6H50z" />
                <path fill="#ff76a9" d="M50 53h40v4H50z" />
                <path fill="#f65cba" d="M52 60h36v3H52z" />
                <path fill="#df4db5" d="M58 66h24v2H58z" />
                <path fill="#287e91" d="M24 66h92v22H24z" />
                <path fill="#345778" d="M24 76h92v12H24z" />
                <g className="system-coast-reflection" fill="#ffb8b9">
                  <path d="M64 67h14v2H64zM66 77h12v2H66z" />
                  <path className="system-coast-ripple" d="M60 72h22v2H60zM58 83h26v2H58z" />
                </g>
                <g fill="#7bdcce">
                  <path className="system-coast-wave" d="M28 70h14v1H28zM44 77h10v1H44zM36 84h12v1H36z" />
                  <path className="system-coast-wave system-coast-wave--late" d="M92 69h18v1H92zM88 79h16v1H88zM98 85h14v1H98z" />
                </g>
                <path fill="#211e37" d="M27 88h7l3-17 5-17h-4l-6 16zM24 85h16v3H24z" />
                <path fill="#211e37" d="M40 54l-9-9h-7v4h8l5 6-9-3h-4v5h9l5 1-9 5-3 6 9-7 6-5 4 8 1 6 3-6-4-10 9 3 5 6-2-9-9-4h-5l5-6 6-2-7-2-6 5z" />
                <path fill="#808080" d="M52 116h40v16H52z" />
                <path fill="#c0c0c0" d="M56 116h28v12H56zM32 132h80v8H32z" />
                <path fill="#fff" d="M32 132h80v4H32z" />
                <path fill="#0a0a0a" d="M28 140h88v4H28z" />
                <path fill="#808080" d="M28 136h4v4h-4zM112 136h4v4h-4z" />
                <path fill="#00ff80" d="M116 100h8v4h-8z" />
              </svg>
              <span className="system-machine-label" aria-hidden="true">VINTAGE VIBE<br />夢 · 640 KB</span>
            </div>
            <dl className="my-computer-details">
              <div>
                <dt>系统：</dt>
                <dd><strong>Vintage Vibe</strong><span>桌面版</span><span>版本 {packageInfo.version}</span></dd>
              </div>
              <div>
                <dt>注册给：</dt>
                <dd><span>访客</span><span>互联网漫游者</span></dd>
              </div>
              <div>
                <dt>计算机：</dt>
                <dd><span>虚拟桌面</span><span>由 React 与 React95 驱动</span><span>内存：640 KB，全部用于怀旧</span></dd>
              </div>
            </dl>
          </div>
        </section>
        <section role="tabpanel" id="system-panel-1" aria-labelledby="system-tab-1" hidden={activeTab !== 1}><HardwarePanel /></section>
        <section role="tabpanel" id="system-panel-2" aria-labelledby="system-tab-2" hidden={activeTab !== 2}><DiagnosticsPanel /></section>
        <section role="tabpanel" id="system-panel-3" aria-labelledby="system-tab-3" hidden={activeTab !== 3}><UpdatesPanel /></section>
        <section role="tabpanel" id="system-panel-4" aria-labelledby="system-tab-4" hidden={activeTab !== 4}><CreditsPanel /></section>
      </TabBody>
      <div className="my-computer-actions"><Button onClick={onClose}>OK</Button></div>
    </div>
  );
}
